<template>
  <div class="Banner_info">
    <!--  :style="{'background-image':`url(${GLOBAL.imageUrl}${info.image}) `}" -->
    <div class="Banner_content">
      <div class="Banner_content_text" v-if="dataInfo">
        <p class="tit">{{ dataInfo.productName }}</p>
        <div class="describe">
          <div
            v-for="(item, index) in dataInfo.keywords.split(',')"
            :key="index"
          >
            {{ item }}
          </div>
          <!-- <div v-if="dataInfo.releaseMech">{{dataInfo.releaseMech}}</div>
          <div v-if="dataInfo.creator">/ {{dataInfo.creator}}</div>
          {{dataInfo.keywords}} -->
        </div>
        <div class="label">
          <div
            class="key_img"
            v-for="(k, j) in dataInfo.sdgGoalIcon.split(',')"
            :key="j"
            style="width: 30px; height: 30px; margin: 4px"
          >
            <img :src="`${GLOBAL.imageUrl}${k}`" width="100%" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .Banner_info {
    width: 100%;
    height: 300px;
    // object-fit: cover;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    // filter: blur(2px);
    z-index: 1;
    background: url("../../../assets/image/News/News_bg.jpg") no-repeat;
    background-size: cover;
    .Banner_content {
      width: 1200px;
      height: 300px;
      margin: 60px auto 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // position: relative;
      .Banner_content_text {
        // height: 160px;
        width: 100%;

        .tit {
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          width: fit-content;
          border-radius: 2px;
          // background: rgba(0, 0, 0, 0.3);
          padding: 4px 20px;
        }
        .describe {
          display: flex;
          flex-direction: row;
          margin-top: 4px;

          div {
            width: fit-content;
            background: rgba(234, 234, 234, 1);
            border-radius: 20px;
            margin-left: 10px;
            padding: 4px 20px;
            display: flex;
            flex-direction: row;
            color: #333;
            font-size: 12px;
          }
        }
        .label {
          display: flex;
          flex-direction: row;
          margin-top: 10px;
          margin-left: 10px;
          img {
            margin-right: 6px;
            border-radius: 4px;
            font-size: 12px;
            color: #333;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .Banner_info {
    width: 100%;
    height: 300px;
    // object-fit: cover;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    // filter: blur(2px);
    z-index: 1;
    background: url("../../../assets/image/News/News_bg.jpg") no-repeat;
    background-size: cover;
    .Banner_content {
      width: 1200px;
      height: 300px;
      margin: 60px auto 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // position: relative;
      .Banner_content_text {
        height: 160px;
        width: 100%;

        .tit {
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          width: fit-content;
          border-radius: 2px;
          background: rgba(0, 0, 0, 0.3);
          padding: 4px 20px;
        }
        .describe {
          width: fit-content;
          border-radius: 2px;
          background: rgba(0, 0, 0, 0.3);
          padding: 4px 20px;
          display: flex;
          flex-direction: row;
          margin-top: 20px;
          color: #fff;
          font-size: 16px;
        }
        .label {
          display: flex;
          flex-direction: row;
          margin-top: 10px;
          img {
            margin-right: 6px;
            border-radius: 4px;
            font-size: 12px;
            color: #333;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .Banner_info {
    width: 100%;
    height: 300px;
    // object-fit: cover;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    // filter: blur(2px);
    z-index: 1;
    background: url("../../../assets/image/News/News_bg.jpg") no-repeat;
    background-size: cover;
    .Banner_content {
      width: 100%;
      height: 300px;
      margin: 60px auto 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // position: relative;
      .Banner_content_text {
        height: 100%;
        width: 100%;

        .tit {
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          margin-top: 30px;
          width: fit-content;
          border-radius: 2px;
          background: rgba(0, 0, 0, 0.3);
          padding: 4px 20px;
        }
        .describe {
          width: fit-content;
          border-radius: 2px;
          background: rgba(0, 0, 0, 0.3);
          padding: 4px 20px;
          display: flex;
          flex-direction: row;
          margin-top: 10px;
          color: #fff;
          font-size: 16px;
        }
        .label {
          display: flex;
          flex-direction: row;
          margin-top: 10px;
          margin-left: 20px;
          img {
            margin-right: 6px;
            border-radius: 4px;
            font-size: 12px;
            color: #333;
          }
        }
      }
    }
  }
}
</style>